export type StorageKeys =
    | 'ico-sp-order'
    | 'ico-group-order'
    | `ico-sp-group-order-${number}`
    | 'ico-social-profile-list-order';

type getMenuItemsOrderType<TData> = {
    storageKey: StorageKeys;
    menuItems: TData[];
    activeItemId?: number;
};

export function getMenuItemsOrder<TData extends { id: number }>({
    storageKey,
    menuItems,
    activeItemId
}: getMenuItemsOrderType<TData>) {
    let results: TData[] = [];
    const existInStorage = localStorage.getItem(storageKey);
    const data: number[] = JSON.parse(existInStorage);
    if (!menuItems) {
        return undefined;
    }
    if (data?.length) {
        let arrayToAdd = menuItems;
        data.forEach((id) => {
            const itemToAdd = arrayToAdd.find((item) => item?.id === id);
            if (itemToAdd) {
                arrayToAdd = arrayToAdd.filter((item) => item?.id !== itemToAdd.id);
                results.push(itemToAdd);
            }
        });
        results = [...results, ...arrayToAdd];
    } else {
        results = menuItems;
    }

    if (!activeItemId) {
        return results;
    }

    return results?.filter((item) => item?.id !== activeItemId);
}
